(function () {
    'use strict';
    EO_PlModalHeaderController.$inject = ['$scope', '$attrs', '$element'];

    function EO_PlModalHeaderController($scope, $attrs, $element) {
//
        var $ctrl = this;

        $ctrl.okModal = function () {
            $ctrl.onOk();
        }
        $ctrl.closeModal = function () {
            $ctrl.onClose();
        }

    }


    var EO_PlModalHeader = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/pl-modal-header/eyeson.pl-modal-header.template.html',
        controller: EO_PlModalHeaderController,
        bindings: {

            'title': '=',
            'isDisabled': '=',
            'onOk': '&',
            'onClose': '&',
            'okTitle': '=?'
        }


    };

    angular
        .module('tikonApp')
        .component('eoPlModalHeader', EO_PlModalHeader)


})();

